import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
// Pages
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { UploadScreen } from './pages/UploadScreen';
import { ValidationScreen } from './pages/ValidationScreen';
import { ProcessingScreen } from './pages/ProcessingScreen';
import { AdminApprovalScreen } from './pages/AdminApprovalScreen';
import { KhatianViewer } from './pages/KhatianViewer';
import { SubmissionsList } from './pages/SubmissionsList';
import { ReportsPage } from './pages/ReportsPage';
import { AuditTrail } from './pages/AuditTrail';
import { OperatorProjnapanList } from './pages/OperatorProjnapanList';
// Gadget Pages
import { GadgetEntryForm } from './pages/gadget/GadgetEntryForm';
import { ZsoSubmissionList } from './pages/gadget/ZsoSubmissionList';
import { GadgetReports } from './pages/gadget/GadgetReports';
import { DsSubmissionList } from './pages/gadget/DsSubmissionList';
import { DsApprovalPage } from './pages/gadget/DsApprovalPage';
import { ProjnapanPreview } from './pages/gadget/ProjnapanPreview';
// Protected Route Wrapper
const ProtectedRoute = ({
  children,
  allowedRoles
}: {
  children: React.ReactNode;
  allowedRoles?: string[];
}) => {
  const {
    isAuthenticated,
    user
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace data-id="element-1" />;
  }
  return <Layout data-id="element-2">{children}</Layout>;
};
export function App() {
  return <AuthProvider data-id="element-3">
      <Router data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/login" element={<LoginPage data-id="element-7" />} data-id="element-6" />

          <Route path="/" element={<ProtectedRoute data-id="element-9">
                <Dashboard data-id="element-10" />
              </ProtectedRoute>} data-id="element-8" />

          <Route path="/upload" element={<ProtectedRoute allowedRoles={['operator', 'zso']} data-id="element-12">
                <UploadScreen data-id="element-13" />
              </ProtectedRoute>} data-id="element-11" />

          <Route path="/submissions" element={<ProtectedRoute allowedRoles={['operator', 'officer', 'zso', 'admin', 'dsminland']} data-id="element-15">
                <SubmissionsList data-id="element-16" />
              </ProtectedRoute>} data-id="element-14" />

          <Route path="/projnapan-list" element={<ProtectedRoute allowedRoles={['operator']} data-id="element-18">
                <OperatorProjnapanList data-id="element-19" />
              </ProtectedRoute>} data-id="element-17" />

          <Route path="/validate" element={<ProtectedRoute allowedRoles={['officer']} data-id="element-21">
                <ValidationScreen data-id="element-22" />
              </ProtectedRoute>} data-id="element-20" />

          <Route path="/processing" element={<ProtectedRoute allowedRoles={['officer', 'admin']} data-id="element-24">
                <ProcessingScreen data-id="element-25" />
              </ProtectedRoute>} data-id="element-23" />

          <Route path="/approve" element={<ProtectedRoute allowedRoles={['admin']} data-id="element-27">
                <AdminApprovalScreen data-id="element-28" />
              </ProtectedRoute>} data-id="element-26" />

          <Route path="/viewer" element={<ProtectedRoute allowedRoles={['operator', 'officer', 'zso', 'admin', 'dsminland']} data-id="element-30">
                <KhatianViewer data-id="element-31" />
              </ProtectedRoute>} data-id="element-29" />

          <Route path="/reports" element={<ProtectedRoute allowedRoles={['officer', 'zso', 'admin', 'dsminland']} data-id="element-33">
                <ReportsPage data-id="element-34" />
              </ProtectedRoute>} data-id="element-32" />

          <Route path="/audit" element={<ProtectedRoute allowedRoles={['admin', 'dsminland']} data-id="element-36">
                <AuditTrail data-id="element-37" />
              </ProtectedRoute>} data-id="element-35" />

          {/* Gadget Routes */}
          <Route path="/gadget/new" element={<ProtectedRoute allowedRoles={['zso']} data-id="element-39">
                <GadgetEntryForm data-id="element-40" />
              </ProtectedRoute>} data-id="element-38" />
          <Route path="/gadget/submissions" element={<ProtectedRoute allowedRoles={['zso']} data-id="element-42">
                <ZsoSubmissionList data-id="element-43" />
              </ProtectedRoute>} data-id="element-41" />
          <Route path="/gadget/reports" element={<ProtectedRoute allowedRoles={['zso', 'dsminland']} data-id="element-45">
                <GadgetReports data-id="element-46" />
              </ProtectedRoute>} data-id="element-44" />
          <Route path="/gadget/ds-submissions" element={<ProtectedRoute allowedRoles={['dsminland']} data-id="element-48">
                <DsSubmissionList data-id="element-49" />
              </ProtectedRoute>} data-id="element-47" />
          <Route path="/gadget/approve" element={<ProtectedRoute allowedRoles={['dsminland']} data-id="element-51">
                <DsApprovalPage data-id="element-52" />
              </ProtectedRoute>} data-id="element-50" />
          <Route path="/gadget/projnapan" element={<ProtectedRoute allowedRoles={['dsminland']} data-id="element-54">
                <ProjnapanPreview data-id="element-55" />
              </ProtectedRoute>} data-id="element-53" />

          <Route path="*" element={<Navigate to="/" replace data-id="element-57" />} data-id="element-56" />
        </Routes>
      </Router>
    </AuthProvider>;
}